export default "__VITE_ASSET__C6mWQBs9__"